<template>
  <v-layout row wrap fill-height>
    <v-toolbar app dense color="primary">
      <v-toolbar-title @click="goToHome" style="color:white;">
        <div style="display: flex; flex-direction: column">
          <div>SuburbanServ - Ops Manager</div>
          <div style="font-size:10px;">v{{ session.Version }}</div>
        </div>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="logout">
        <v-icon>mdi-logout-variant</v-icon>
      </v-btn>
    </v-toolbar>
    <v-content>
      <router-view></router-view>
    </v-content>

    <!-- <v-bottom-nav :active.sync="activeBtn" :value="true" color="primary" height="50" fixed>
      <v-btn flat color="white" value="Customers">
        <span>Tasks</span>
        <v-icon>mdi-calendar-check</v-icon>
      </v-btn>

      <v-btn flat color="white" value="Meeting">
        <span>Meeting</span>
        <v-icon>mdi-meetup</v-icon>
      </v-btn>
    </v-bottom-nav> -->
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      session: {
        version: "3.0.0"
      }
    };
  },
  computed: {
    activeBtn: {
      get() {
      },
      set(val) {
        let self = this;

        if (val != null) {
          self.$router.push(`/OpsManager/${val}`);
        }
      }
    }
  },
  mounted() {
    if (sessionStorage["Config"] != null)
      this.session = JSON.parse(sessionStorage["Config"])
  },
  methods: {
    logout() {
      this.$router.push(`/`);
    },
    goToHome() {
      this.activeBtn = null;
      this.$router.push("/OpsManager");
    }
  }
};
</script>